import { LitElement, html } from '@hh/global.js'

class CollectionFilterInfo extends LitElement {
  static properties = {
    open: {
      type: Boolean,
      reflect: true
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleCloseTrigger()
    this.handleEscKey()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  updated() {
    if (this.open) {
      this.closest('section').style.zIndex = "1000";
    } else {
      this.closest('section').style.zIndex = "";
    }
  }

  handleCloseTrigger() {
    const filterDrawerClose = this.querySelectorAll('.js-collection-filter-info-close')

    filterDrawerClose?.forEach(el => {
      el.addEventListener('click', () => {
        this.open = false
      })
    })
  }

  handleEscKey() {
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.open = false
      }
    })
  }

  render() {
    return html`<hh-focus-trap active="${!!this.open}"><slot></slot></hh-focus-trap>`
  }
}

customElements.define('collection-filter-info', CollectionFilterInfo)
